import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../styles/diario.scss'

const Veiculo = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.veiculo.modelo} / {props.veiculo.marca}</h5></Card.Header>
                    <Card.Body>
                        <p>Secretaria: {props.veiculo.secretaria}</p>
                        <p>Placa: {props.veiculo.placa}</p>
                        <p>Finalidade: {props.veiculo.finalidade}</p>
                        <p>Tipo: {props.veiculo.tipo}</p>
                        <p>Situação: {props.veiculo.situacao}</p>
                        <p>Categoria: {props.veiculo.categoria}</p>
                        <p>Proprietário: {props.veiculo.proprietario}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Veiculo;